/**
 * @file パスワード表示
 */
'use strict';

/**
 * @classname FormPasswordView
 * @classdesc パスワード表示
 */
export default class FormPasswordView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('FormPasswordView.constructor');
		this._$e = $e;
		this._$input = $e.closest('.form-group-content-inner--password').find('input');
		this._$icon = $e.find('i.icon--eye');
		this._show = false;
		$e.on('click', () => this.onClick());
	};
	/**
	 * クリックのコールバック
	 *
	 * @memberof FormPasswordView
	 * @return {undefined}
	 */
	onClick() {
		console.log('FormPasswordView.onClick');
		if(this._show){
			this._$input.attr('type', 'password');
			this._$icon.removeClass('close')
			this._show = false;
		}else{
			this._$input.attr('type', 'url');
			this._$icon.addClass('close');
			this._show = true;
		}
	};
}
